import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { ApiError } from '@/types/api.types';
import { selectActiveAccount, useAuthStore } from '@features/auth';

import { recordConsent } from '../api/clientsApi';
import type { RecordConsentRequest } from '../types';

interface RecordConsentVars {
  clientId: string;
  request: RecordConsentRequest;
}

export function useRecordConsent() {
  const queryClient = useQueryClient();
  const activeAccount = useAuthStore(selectActiveAccount);
  const accountId = activeAccount?.accountId ?? '';

  return useMutation<void, ApiError, RecordConsentVars>({
    mutationFn: ({ clientId, request }) => recordConsent(accountId, clientId, request),
    onSuccess: (_data, { clientId }) => {
      queryClient.invalidateQueries({ queryKey: ['client', accountId, clientId] });
    },
  });
}
